"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
    title: 'International Horticultural Exhibition 2019 Beijing China',
    register1: 'Sign Up',
    register2: 'Sign Up',
    login1: 'Login',
    login2: 'Login',
    leave: 'Sign out',
    back: 'Home Page',
    orders: 'My Orders',
    ticket1: 'Ordinary Standard Day Ticket',
    ticket2: 'Concessionary Standard Day Ticket',
    ticket3: 'Ordinary Designated Day Ticket', 
    ticket4: 'Concessionary Designated Day Ticket',
    ticket5: 'Standard Day Tickets',
    ticket6: 'Designated Day Ticket',
    rules: 'Applicable Rules ',
    immediately: 'Booking Now',
    notice: 'Notice to Tourists',
    prompt: 'Please Read The "Instructions for Admission" Carefully Before Purchasing Tickets.',
    accountRegister: 'Sign Up',
    inputPhone: 'Mobile Number',
    inputPhonea: 'Mobile Number And Verification Code',
    inputPsword: 'Password',
    inputCode: 'Verification Code',
    inputCode1: 'Verification Code',
    inputCode2: 'Please Enter the Verification Code', 
    getCode: 'Get code', 
    accountLogin: 'User Login',
    forgetPsword: 'Forgotten Your Password',
    // goRegister1: "Don't have an account yet?",
    goRegister2: "Register Now",
    loginDiv: 'Login Now',
    point1: 'Phone Number Format Is Incorrect',
    point2: 'You Have Logged in Successfully.',
    footWord1: 'Copyright © International Horticultural Exhibition 2019 Beijing China All Rights Reserved',
    footWord2: '',
    footWord3: 'Address: Floor 9 Shougang Tiyu Building No.159 Fushi Street Shijingshan District Beijing',
    footWord4: 'Tel: 86-10-86484017',
    footWord5: 'Official Weibo',
    footWord6: '',
    footWord7: 'Zip Code: 100043',
    footWord8: 'Official WeChat',
    footWord9: 'Official APP',
    chooseTime: 'Choosing Admission Time',
    am: 'A.M.',
    pm: 'P.M.',
    atNight: 'Evening',
    timeSelection: 'Time Period',
    selectDate: 'Ticketing System Reminder: Please Choose the Date and Time Period First.',
    selectDate1: 'Please Choose the Date and Time Period First.',
    selectTime: 'Please Choose Time Period.',
    selectTime1: 'Ticketing System Reminder：Please Choose Time Period.',
    notOptional: 'Not Optional',
    optional: 'Optional',
    selected: 'Selected',
    optionalTodal: 'Today',
    ticketKinds: 'Ticket Type',  
    next: 'Next',
    confirm: 'OK',
    confirm1: 'OK',
    pleaseInformation: "Please Add The Ticket Purchaser Information And Perform Real Name Certification.",
    safelyUpgrade: 'Complete Certification to Prevent Others from Using Identity, Safely Upgrade',
    appointmentTime: 'Appointment time',
    completeInformation: 'Improve Real-Name Certification Information',
    addInformation: "Buyer Information",
    phoneVerification: 'Mobile Number Verification',
    cellPhone: 'Mobile Number',
    cellPhone1: 'Mobile Number',
    verificationCode: 'Verification code',
    sendCode: 'Get Code',
    readTerms1: 'I Acknowledge That I Have Read and Agree to ',
    readTerms2: 'The TICKET TERMS',
    enteringPark: 'Please Take the Valid ID to Enter After Booking the Tickets.',
    pleaseAddInformation: "Please Add the Information of Ticket Buyers",
    ticketInformation: 'Ticket information',
    verified: 'Verified',
    submitCertification: 'Submit Certification',
    name: 'Name',
    nameEmpty: 'Please Enter the Name',
    nameEmpty1: 'Please Enter the Real--Name',
    typeCertificate: 'Type of Identity',
    selectIdType: 'Please Choose the Type of Identity',
    idCard: 'Identity Card',
    passport: 'Passport',
    hongKongCard: ' Mainland Travel Permits for Hong Kong And Macao Residents',
    mTPs: 'Mainland Travel Permits For Taiwan Residents',
    iDNumber: 'ID Number',
    pleaseID: 'Please Enter The ID Number',
    confirmID: 'Confirm The ID Number',
    againID: 'Please Enter The ID Number Again',
    wrongIDCard: 'Incorrect ID Number',
    wrongOtherCard: 'Please Enter The Correct ID Number',
    twoWrongID: 'Inconsistent Two Input ID Numbers',
    // pleaseChinaName: 'Please enter the Chinese name',
    sentCode: 'Verification Code Has Been Sent.',
    fillInformation: 'Ticketing System Reminder：Please Fill in The Ticket Purchaser Information',
    fillPhone: 'Ticketing System Reminder：Please Fill in The Mobile Phone Number And Verification Code.',
    fillPhone1: 'Ticketing System Reminder：Please Fill in The Mobile Phone Number',
    pleaseTerms: 'Ticketing System Reminder：Please Read And Agree to The "Purchasing Terms"',
    savedSuccess: 'The Order Is Saved Successfully, Please log Here to Pay.',
    confirmTicket: 'Confirm The Ticket Information',
    submit: 'Submit',
    addMore: 'Add',
    noo: 'No.',
    orderNum: 'Order No.',
    orderInformation: 'Order Information',
    bookingTimg: 'Booking Time',
    bookingNum1: 'The Quantity of Tickets',
    bookingNum: 'Number',
    orderCode: 'Order Confirmation Code',
    orderStatus: 'Order Status',
    toPaid: 'To pay',   // To Be Paid
    paid: 'Paid',
    refunding: 'Refunding',
    refunded: 'Refunded',
    orderinvalid: 'Order Invalid',
    notIssued: 'Ticket Not Issued',
    ticketIssued: 'Ticket Issued',
    total: 'Total',
    operations: 'Operating',
    delete: 'Delete',
    changeTicket: 'Change',   // Change Tour Date
    refund: 'Refund',
    refundApplication: 'Refund Application',
    wantRefund: 'Do You Want to Refund Your Ticket?',
    totalRefund: 'Total Refund',
    pleaseAlipay: 'Please Use Wechat  Alipay Or Quick Pass to Scan The Above Two--Dimensional Code.',
    noticeMinutes: 'Warm Tip:  The Order Is Valid For 30 Minutes.',
    noticeMinutes1: 'Warm Tip:  The Order Is Valid For 30 Minutes. Do Not Close the Window Until Payment Is Completed.',
    SuccessfulOrder: 'Successful order payment',
    wantDelete: 'Do You Want to Delete This Order?',
    tips: 'Notice',
    cancel: 'Cancel',
    deleteSuccessfully: 'Order Deleted Successfully',
    refundSuccessful: 'Successful Refund',
    yourOrder: 'Your order is as follows',
    calendarTime: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    renminbi: ' ¥',
    registrationSuccessful: 'Registration Success',
    rePassword: 'Retrieve the Password',
    newPassword: 'Please Enter New Password',
    passwordSuccessful: 'You Have Changed Your Password Successfully.',
    reservationFull: 'Reservation Is Full，Please Select Another Tour Date.',
    exitSuccess: 'Exit Successfully',
    closed: 'Close',
    invoiceRise: 'Invoice Type',
    unitInvoice: 'Business Invoice',
    personalInvoiceL: 'Self-Billing Invoice',
    taxpayerNumber: 'Tax number',
    noteInvoice: 'Invoice note',
    emailInvoice1: 'Received Email Address',
    emailInvoice: 'Email Address',
    phoneInvoice: 'Phone Number',
    selectInvoice: 'Please Choose The Type of Invoice',
    fillInvoice: 'Please Enter The Tax number',
    errorEmail: 'E-mail Format Is Incorrect',
    networkTimeout: 'Network Timeout',
    notFeature: 'Tips: The function to Be Opened',
    fetObtain: 'Issue Electronic Invoice',
    changeLang: '中文',
    getAgain: 'seconds',
    realName: 'Real-Name Registration',
    currentChoice: 'Current Selections',
    changePhone: 'Change Mobile Number',
    rmbTicket: 'Ticket',
    numVerification: 'Mobile Number Verification',
    noMatchText: 'Reservation Is Full，Please Select Another Tour Date.',
    paymentAmount: 'Payment',
    ruDate: 'Date of Admission',
    gardenComfort: 'Prediction of Comfort Degree of Tou',
    comfortable: 'Comfortable',
    moderate: 'Generally',
    crowded: 'Crowded',
    timeChange: 'Please Select The Date of The Change',
    changeDate: 'Change Date',
    tipTip1: 'Tips: Weekday Tickets Can Only Be Changed to The Viewing Date, And The Ticket Type Bannot Be Changed; The Designated Day Ticket Can Be Changed to Any Date.',
    tipTip: 'Note: Weekday tickets cannot be changed to designated day tickets; reservation tickets can only be changed after the original appointment date.',
    noChangeType: 'Ticketing System Reminder：The Weekday Tickets Cannot Be Changed to Designated Day Tickets',
    reselectChange: 'Ticketing System Reminder：Please Reselect The Viewing Date And Time Period After The Change.',
    successfullyChanged: 'Successfully Changed',
    pleaseSelecttt: 'Ticketing System Reminder：Please Select The Viewing Date And Time Period After The Change.',
    onlyOrders: 'Ticketing System Reminder：Sorry, You Can Only Buy Up to 6 Tickets for An Order.',
    onlyoneticket: 'Only One Ticket Can Be Purchased for The Same ID Number',
    enterdigits: 'Please Enter A Password of 6 to 30 Digits, A Combination of Numbers And Letters',
    orderexpired: 'Order Invalid',
    sorryError: 'Sorry, Currently Browsing An Error Occurred on The Page!',
    checkUrl: 'Please Check That The URL You Entered, Click The Button Below to Return',
    tiptip: 'Notice: If The Name And ID Number Do Not Match, You Will Not Be Able to Enter The park.',
    freechange: '6 Years Old (Born on January 1, 2013 And After) Free of Charge for The Following children',
    codeerror: 'Incorrect Verification Code',
    noticeList: [       // 首页 - 入园须知的内容
        {
            title: 'Quick Entry by Showing ID Cards',
            content: 'To facilitate quick and orderly entry into the Expo Site, please wait in lines and get your ID card ready for pre-check, ticket check and security inspection before entering. In the process of ticket check, those who hold concessionary tickets must show their valid certificates that prove they are entitled for such concession. Thank you for your cooperation.'
        },
        {
            title: 'Safe Tour to the Expo',
            content: 'For the sake of your personal safety, please don’t take anything that may disturb other visitors or undermine the order of the Expo Site such as pets, drones, kites, handheld transceivers, and speakers. Children and seniors who are physically inconvenienced shall be accompanied by able adults. Except for wheelchairs for the elderly and the disabled and strollers for children, no vehicles are allowed to enter the Expo Site. In case of emergencies, please ask help from staff members around you. '
        },
        {
            title: 'Taking Action to Safeguard the Environment',
            content: 'To maintain a green, beautiful environment for yourself and others, please follow relevant travel etiquettes, protect public facilities, maintain environmental sanitation and care plants growing in the Expo Site. Behaviors such as climbing or destroying structures and exhibits are prohibited. '
        },
        {
            title: 'Orderly Travel by Maintaining Harmony and Politeness',
            content: 'For the safety of visitors, staff members may temporarily restrict accession into some gardens and pavilions and evacuate tourists in the event of overcrowding. Please follow their instruction. Thank you for your cooperation and understanding.'
        },
        {
            title: 'Enjoying Considerate Service and Having Fun',
            content: 'Tourist service centers in the Expo Site provide services including information inquiry, storage of personal belongings, wheelchair and stroller renting, lost & found service, and search for missing persons. We hope you have a good time at the Expo. '
        }
      ],
    noticephone1: 'You can dial the service hotline at',
    noticephone2: '86-10-86484017',
    noticephone3: 'for inquiry, suggestion or complaint. Thanks for your attention.',
    loadList: [      // 购票页 - 购票须知的内容
        {
          title: 'I. Notice on Ticketing',
          content: [
              { con: 'All ticket buyers and holders of the International Horticultural Exhibition Beijing, China 2019 (hereinafter referred to as “Beijing Expo 2019”) shall read the “Ticketing Information” carefully and follow the terms and conditions stipulated hereby. Buying the tickets of Beijing Expo 2019 requires the use of real names, which means all visitors must input their ID information to buy or book tickets online. ' }
          ]
        },
        {
          title: 'II. Ticket Categories and Prices',
          content: [
              { con: '1. Individual tickets of Beijing Expo 2019 are categorized into “designated day tickets” and “standard day tickets.” The holder of a designated day ticket is allowed to enter the Expo Site at the designated day or any standard day, and the holder of a standard day ticket is only allowed to enter the Expo Site at any standard day.' },
              { con: '2. Beijing Expo 2019 is scheduled to last for 162 days from April 29 to October 7, of which there are 15 designated days, including the opening day (April 29, 2019), the Labor Day holiday (May 1, 2019), the Dragon Boat Festival holiday (June 7-9, 2019), the Mid-Autumn Festival holiday (September 13-15, 2019), and the National Day holiday (October 1-7, 2019, and October 7 also marks the closing day). Apart from the foresaid designated days, all of the rest 147 days are standard days.' },
              { con: '3. Designated day tickets are further categorized into “ordinary designated day tickets” and “concessionary designated day tickets,” and standard day tickets are also further categorized into “ordinary standard day tickets” and “concessionary standard day tickets.” The applicable conditions and prices for tickets bought online are as follows: ' },
          ],
          // table: {
              trone1: 'Type',
              trone2: 'Category',
              trone3: 'Applicable conditions',
              trone4: 'Price(yuan/person)',
              trtwo: 'Individual tickets',
              trthree1: 'Designated day tickets',
              trthree2: 'Ordinary designated day ticket',
              trthree3:[ 'Applicable to all people', 'Applicable on the designated day or any standard day for one-time use of one person' ],
              trthree4: '160.00',
              trfour1: 'Concessionary designated day ticket',
              trfour2: [
                  'Applicable to people aged at 60 or above (namely, those born on December 31, 1959 or earlier)',
                  'Applicable to students below the age of 18 (namely, those born on January 1, 2001 or later)',
                  'Applicable to children aged at 6-14 (namely, those born on January 1, 2005 or later) and with a height of more than 1.3 meters ',
                  'Valid identity certificates are required to show when buying tickets and entering the Expo Site',
                  'Applicable on the designated day or any standard day for one-time use of one person'
              ],
              trfour3: '100.00',
              trfive1: 'Standard day tickets',
              trfive2: 'Ordinary standard day ticket',
              trfive3: [ 'Applicable to all people', 'Applicable on any standard day for one-time use of one person'],
              trfive4: '120.00',
              trsix1: 'Concessionary standard day ticket',
              trsix2: [
                  'Applicable to people aged at 60 or above (namely, those born on December 31, 1959 or earlier)',
                  'Applicable to students aged below 18 (namely, those born on January 1, 2001 or later)',
                  'Applicable to children aged at 6-14 (namely, those born on January 1, 2005 or later) and with a height of more than 1.3 meters',
                  'Valid identity certificates are required to show when buying tickets and entering the Expo Site',
                  'Applicable on any standard day for one-time use of one person'
              ],
              trsix3: '80.00',
          // },
          contentother1: 'Note: Admission to the Expo Site is free for children (those below the age of 14, namely born on January 1, 2005 or later) at an age below 6 years old (namely, born on January 1, 2013 or later) or with a height of 1.3 meters or less.' ,
          contentother2: '4. Ticket sales are divided into two periods: the pre-sale period (from January 19 to April 28, 2019) and the expo period (from April 29 to October 7, 2019). Buyers of non-concessionary tickets can get 10% off during the pre-sale period. ' ,
        },
        {
          title: 'III. Ticket Booking and Admission',
          content: [
              { con: '1. Buying the tickets of Beijing Expo 2019 requires the use of real names, and all visitors are required to input information of their second-generation ID cards (or valid passports, mainland travel permits for Hong Kong and Macao residents and mainland travel permits for Taiwan residents) to buy or book tickets online. ' },
              { con: '2. Online ticket buyers need to reserve the day to enter the Expo Site. Beijing Expo 2019 sets an upper limit for the number of daily visits. Visitors can buy tickets online in advance, but in case that the number of tickets sold reaches a day’s upper limit, ticket sales of that day will cease. On-site ticket offices only provide individual tickets of the day.' },
              { con: '3. The holder of each valid ID certificate (ID card, passport, mainland travel permit for Hong Kong and Macao residents or mainland travel permit for Taiwan residents) is permitted to buy or book one ticket each day.' },
              { con: '4. People aged at 60 or above (namely, those born on December 31, 1959 or earlier) and children aged below 18 (namely, those born on January 1, 2001 or later) may buy concessionary tickets online. ' },
              { con: '5. Other groups to whom concessionary tickets are applicable (including the disabled, in-service soldiers and officers, and students at institutions of regular higher education) need to buy tickets on site at designated ticket windows (near Gate 1, Gate 2 and Gate 5) and show their valid second-generation ID cards and certificates that prove they are entitled for such concession.' },
              { con: '6. Ticket sales, online and offline, close at 20:00 each available day.' },
              { con: '7. Buyers should check the categories, volumes and payments of the tickets when buying, and are entitled to ask for invoices equal to the amounts they paid. ' },
              { con: '8. Visitors who enter the Expo Site by swapping their second-generation ID cards, passports, mainland travel permits for Hong Kong and Macao residents or mainland travel permits for Taiwan residents at 16:00 or later (subject to automated recording of relevant check-in system), if needed, can enter the Expo Site again the next day by swapping aforesaid ID certificates (except that the day follows a standard day). ' },
          ],
        },
        {
          title: 'IV. Ticket Changing and Refunding',
          content: [
              { con: '1. Prior to check-in, online ticket buyers can apply to get their tickets changed or refunded once before 20:00 on the reserved day of admission via the channel they bought such tickets. A designated day ticket can be changed into a ticket for any designated day or standard day after the day when relevant application is submitted (buyers will not be refunded for any price differences). A standard day ticket can be changed into a ticket for any standard day after the day when relevant application is submitted. If a ticket holder doesn’t enter the Expo Site and change and refund the ticket before 20:00 on the day of admission as booked, his or her ticket will be considered void and thus cannot be changed or refunded. ' },
              { con: '2. One can book as many as six tickets per order. If needed, all tickets in one order must be changed or refunded together, rather than be changed or refunded partially. ' },
              { con: '3. For visitors who apply for refunding, the channel via which they buy tickets will be responsible for relevant refunding procedures. For details, please enquiry relevant ticket-selling channels.' },
          ],
        },
        {
          title: 'V. Ticket Checking',
          content: [
              { con: '1. Those who enjoy free admission and visitors who hold tickets both need to show their valid ID certificates (including ID cards, passports, mainland travel permits for Hong Kong and Macao residents and mainland travel permits for Taiwan residents) before entering the Expo Site. ' },
              { con: '2. Visitors who hold concessionary tickets need to show the original certificates that prove they are entitled for such concession and their valid ID certificates before entering the Expo Site via designated entrances.' },
              { con: '3. Visitors who register their ID card information when buying tickets online can directly enter the Expo Site via designated entrances of Gate 1, Gate 2 and Gate 5 by showing their valid ID cards. ' },
              { con: '4. Visitors who register the information of their passports, mainland travel permits for Hong Kong and Macao residents and mainland travel permits for Taiwan residents when buying tickets online can directly enter the Expo Site via designated entrances of Gate 1, Gate 2 and Gate 6 by showing their valid certificates that they registered online. ' },
              { con: '5. Visitors who have bought tickets but fail to check in due to loss or damage of their certificates or other situations can get a temporary admission permit at on-site ticket offices by showing their temporary ID certificates issued by relevant public security departments and enter the Expo Site within the valid period of the temporary admission permit. ' },
              { con: '6. Visitors who book tickets via the same order must show all of their valid ID certificates registered when buying tickets to enter the Expo Site. Once any of them successfully checks in, all tickets booked via the order cannot be changed or refunded. ' },
          ],
        },
        {
          title: 'VI. Opening Hours',
          tablesix: [
              [ 'Opening at', 'Deadline for ticket sales', 'Deadline for admission', 'Closing at' ],
              [ '08：00', '20:00', '20:00', '21:00' ],
          ],
        },
        {
          title: 'VII. Others',
          content: [
              { con: '1. Beijing International Horticultural Exhibition Coordination Bureau will publish information about ticketing in the form of notices. The public can inquire relevant information via the official website of Beijing Expo 2019 (http://www.horti-expo2019.com/) or the service hotline of Beijing Expo 2019 (86-10 86484017). ' },
              { con: '2. Beijing International Horticultural Exhibition Coordination Bureau has the right to adjust ticketing terms and conditions according to operational situations and will inform the public and relevant institutions of such adjustments, if any. ' },
              { con: '3. All exhibitions and activities held in the Expo Site during Beijing Expo 2019 will not charge extra fees unless otherwise stipulated.' },
              { con: '4. Beijing International Horticultural Exhibition Coordination Bureau reserves the right of final interpretation. ' },
          ],
        },
        
    ],
    selectInvoiceType: 'Preferred invoice type',
    fillInvoiceName: 'Please fill in the name or details of the company.',
    fillInvoiceNamesss: 'Please check the name or details of the company again.',
    invoiceEmail: 'Please fill in the email address.',
    successfulBilling: 'Invoice has been successfully sent to the email. Please check it.',
    fillInvoiceNo: "Please Enter The Tax number.",
    nofill: 'Please check the information again. Only English and Chinese, Numbers, and special symbols like (, and .) are supported.',
    tiperrorsss: 'Friendly reminder: once the invoice is issued, it cannot be altered. Please make sure related information is corrected. (The date of issue is the same as the date of application.)',
    tiperrorsss1: 'Friendly reminder:',
    tiperrorsss2: 'once the invoice is issued, it cannot be altered. Please make sure related information is corrected. (The date of issue is the same as the date of application.)',
    personaltips: "If the self-employed, executive branches, public institutions, social organizations, and etc., do not have a taxpayer identification number, please also select the 'individual' option to apply for invoice. ",
    tinvoicetype: 'Invoice types',
    tinvoicename: 'Name/Details of the Company',
    downloadinvoice: 'Download Electronic Invoice',
    notloggen: 'You have logged out unfortunately. Please try again.',
    travelmodeselection: 'Trip Plans',
    pleasetravelmode: 'Your Choice',
    optionsTravel: [ 
        {
            value: '1',
            label: 'Beijing Horticultural Exhibition Bus Line',
            children: [
                { value: '1', label: 'Zhuxinzhuang Satation - Beijing Subway' },
                { value: '2', label: "Bei'anhe Station - Beijing Subway" },
                { value: '3', label: 'Tiantongyuan North Satation - Beijing Subway' },
                { value: '4', label: 'Jinanqiao Station - Beijing Subway' },
                { value: '5', label: "Xi'erqi Station - Beijing Subway" },
                { value: '6', label: 'Liuliqiao East Station - Beijing Subway' },
                // { value: '7', label: 'Beijing Horticultural Exhibition - P3 Parking Lot' },
            ]
        },
        {
            value: '2',
            label: 'Line S2'
        },
        {
            value: '3',
            label: '919/919 Express etc.'
        },
        {
            value: '4',
            label: 'Self Drive'
        },
        {
            value: '5',
            label: 'Taxi'
        },
        {
            value: '6',
            label: 'Other choices'
        }
    ],
    discountedssss: 'Discount tickets can be rescheduled after the original time.',
    cannotbuy: 'After 18:00, you cannot purchase the ticket on the same day. Please select other date. ',
    cannotchange: 'After 18:00, you cannot reschedule the ticket on the same day. Please check carefully.',
    invoiced: 'Invoice Issued',
    ondaypay: 'You shall enjoy the discount before 23:59 on the same day. Please ensure prompt payment.',
    twoadvance1: 'You shall get 10% disount if you buy tickets online two days or more in advance.',
    twoadvance: 'Notice: You shall get 10% disount if you buy tickets online two days or more in advance.',
    friendlyReminder:[
        'Friendly reminder:',
        'Book a two-day advance ticket and you will enjoy a 10% discount!',
        'Discount tickets can be rescheduled after the original time.',
        'If an invoice is required, please submit the application online within 7 days from the original day of purchase.',
        'If you need to refund or change your ticket, please be sure to complete the operation before 20:00 on the same day.',
        'After 18:30, please enter the park in the No. 5 gate  or No. 6 gate .',     
    ],
    apptiptip: 'Ticketing System Reminder：For tickets purchased by APP, please pay at APP',
    


};
exports.default = _default;


// WEBPACK FOOTER //
// ./src/language/en-US.js